import styled from 'styled-components';
import { CHART_COLORS } from '../../utils';

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	height: 32px;
	width: 100%;
	align-items: center;
`;

export const GreyWrapper = styled.div`
	position: absolute;
	display: flex;
	height: 20px;
	width: ${({ width }) => `${width}%` || 0};
	background-color: ${CHART_COLORS.GREY};

	${({ offset }) => offset && `margin-left: ${offset}%;`};
`;

export const BudgetWrapper = styled.div`
	position: absolute;
	display: flex;
	height: 12px;
	width: ${({ width }) => `${width || 0}%`};
	background-color: ${({ isOverrun }) =>
		isOverrun ? CHART_COLORS.RED : CHART_COLORS.GREEN};

	${({ offset }) => offset && `margin-left: ${offset}%;`};
`;

export const TargetWrapper = styled.div`
	position: absolute;
	display: flex;
	height: 20px;
	width: ${({ width }) => `${width || 0}%`};
	background-color: transparent;
	border-right: 2px solid ${CHART_COLORS.AMBER};
`;
